var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnRollLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "104.535px",
    height: "27.549px",
    viewBox: "0.645 0.279 104.535 27.549",
    enableBackground: "new 0.645 0.279 104.535 27.549",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M37.923,12.807H2.681c-1.124,0-2.036-0.911-2.036-2.036V10.77c0-1.124,0.911-2.036,2.036-2.036h35.242 c1.124,0,2.036,0.911,2.036,2.036v0.001C39.959,11.895,39.047,12.807,37.923,12.807z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M32.662,4.351H7.942c-1.124,0-2.036-0.911-2.036-2.036V2.314c0-1.124,0.911-2.036,2.036-2.036h24.72 c1.124,0,2.036,0.911,2.036,2.036v0.001C34.698,3.439,33.786,4.351,32.662,4.351z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M32.662,17.191H7.942c-1.124,0-2.036,0.911-2.036,2.036v0.001c0,1.124,0.911,2.036,2.036,2.036h5.556 c0.667,0,1.208,0.541,1.208,1.208v3.345c0,1.695,1.95,2.647,3.286,1.606l7.355-5.729c0.358-0.278,0.798-0.43,1.251-0.43h6.064 c1.124,0,2.036-0.911,2.036-2.036v-0.001C34.698,18.102,33.786,17.191,32.662,17.191z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnRollLogoWhite);
export default __webpack_public_path__ + "static/media/OnRollLogo-white.b38c6bd7f80394808a7d7c42f8ad5cf1.svg";
export { ForwardRef as ReactComponent };